import SSORegistrationSettings from './components/sso/sso-registration-settings';
import AdvancedRegistrationSettings from './components/advance/advanced-registration-settings';
import EmailsRegistrationSettings from './components/emails/EmailsRegistrationSettings';
import AccessTypeRegistrationSettings from './components/access/access-type-registration-settings';
import GatingRegistrationSettings from './components/gating/gating-registration-settings';
import useComputedRegistrationSettings from './hooks/use-computed-registration-settings';
import SlideDownCard from '@ui/cards/slide-down-card/slide-down-card';
import SignInOptions from './components/sso/sign-in-options/sign-in-options';
import ExternalRegistrationLink from './components/advance/external-registration-link';
export default function RegistrationSettings() {
  const { customSsoEnabled, registrationSettings, passwordGateEnabled, registrationOn } =
    useComputedRegistrationSettings();
  const isExternalRegistrationOn = !!registrationSettings?.externalRegistration?.isOn;
  const isDisabled = !!registrationSettings && !registrationOn;
  const isNativeRegistration = !customSsoEnabled && !isExternalRegistrationOn && !isDisabled;

  return (
    <div className="flex-column gap-8">
      <AccessTypeRegistrationSettings />

      <div className="flex-column">
        <SlideDownCard autoGrow open={isExternalRegistrationOn} animateOnInitialLoad={false}>
          <ExternalRegistrationLink />
        </SlideDownCard>

        <SlideDownCard autoGrow open={customSsoEnabled} animateOnInitialLoad={false}>
          <SSORegistrationSettings />
        </SlideDownCard>

        <SlideDownCard autoGrow open={isNativeRegistration} animateOnInitialLoad={false}>
          <div className="flex-column gap-24">
            <GatingRegistrationSettings />
            <SlideDownCard autoGrow open={!passwordGateEnabled} animateOnInitialLoad={false}>
              <SignInOptions />
            </SlideDownCard>
            <EmailsRegistrationSettings />
          </div>
        </SlideDownCard>
      </div>

      <div className="margin-t-16">
        <AdvancedRegistrationSettings />
      </div>
    </div>
  );
}
